module.exports = __webpack_public_path__ + "src/assets/images/upload_icon.4a440dc1214c77bf89147eec4de16b5e.png";